import script from "./LeadsPerDayChart.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsPerDayChart.vue?vue&type=script&setup=true&lang=js"

import "./LeadsPerDayChart.vue?vue&type=style&index=0&id=15a9bc0e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15a9bc0e"]])

export default __exports__